import { Controller } from '@hotwired/stimulus';
import Sidebar from '../Sidebar';

/**
 * Controller para gestionar el layout principal de la App. Si cambia porque cargamos
 * o porque Turbo reemplaza el contenido, reconectamos todo lo necesario (el sidebar)
 */
export default class extends Controller {
  connect() {
    this.sidebar = new Sidebar(this.element);
    this.sidebar.start();
  }
}
